import { Flex, Text } from '.';
import { theme } from '../../design-system';
import { Icon } from '../../../../component-library';
import { usePostMessage, useReceiveMessage } from '../../../../context/messageContext';
import { useEffect, useState } from 'react';
import { useTestContext } from '../../../../context/testContext';
import styled from '@emotion/styled';

const PatientMovementDetector = () => {
  const { testData } = useTestContext();
  const postMessage = usePostMessage();
  const receivedMessage = useReceiveMessage();
  const [showRecalculateButton, setShowRecalculateButton] = useState(false);
  const [indicatorColor, setIndicatorColor] = useState(testData.testMode === 'auto' ? theme.colors.warning : theme.colors.success);

  useEffect(() => {
    if (receivedMessage?.type !== 'patientMovementDetected') return;
    const { patientIsMoving, patientDistance } = receivedMessage?.content;
    if (patientIsMoving && !patientDistance) return setIndicatorColor(theme.colors.warning);
    if (patientIsMoving) return setIndicatorColor(theme.colors.error);
    return setIndicatorColor(theme.colors.success);
  }, [receivedMessage]);

  useEffect(() => {
    if (testData.testMode === 'auto' && indicatorColor === theme.colors.success) {
      setShowRecalculateButton(true);
    } else setShowRecalculateButton(false);
  }, [testData.testMode, indicatorColor]);

  useEffect(() => {
    if (testData.testMode === 'manual') setIndicatorColor('lightgrey');
  }, [testData.testMode]);

  return (
    <Flex column centered width='100%'>
      <Text marginBottom='0.5rem' fontSize='0.875rem'>
        {`Movement Detector`}
      </Text>

      <Flex
        centered
        backgroundColor={indicatorColor}
        border={`3px solid ${indicatorColor}`}
        borderRadius='4px'
        width='100%'
        height='2rem'
        position='relative'
      >
        <Text fontSize='0.75rem'>{indicatorColor === theme.colors.warning ? 'Calculating...' : null}</Text>
        {showRecalculateButton && <RecalculateDistanceButton onClick={() => postMessage({ type: 'recalculateDistance' })} />}
      </Flex>
    </Flex>
  );
};

const RecalculateDistanceButton = ({ ...props }) => {
  return (
    <RecalculateDistanceContainer {...props}>
      <Icon icon='loop2' size={14} color='#fff' />
    </RecalculateDistanceContainer>
  );
};

const RecalculateDistanceContainer = styled(Flex)`
  background-color: ${(props) => (props.disabled ? 'lightgrey' : 'rgba(255, 255, 255, 0.3)')};
  width: 1.5em;
  aspect-ratio: 1;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  justify-content: center;
  align-items: center;

  & svg {
    display: block !important;
  }
`;

export default PatientMovementDetector;
